import moment from 'moment'
const Utils = {
    convertDateLocal(date, format, local) {
        return moment(date).locale(local).format(format)
    },
    convertDate(date, format) {
        return moment(date).format(format)
    },
    convertDDMMYYYYToYYYYMMDD(date) {
        var dateRep = date.replaceAll('/', '-')
        return dateRep.split("-").reverse().join("-");
    },
    getDateNow() {
        return moment().format('LLLL')
    },
    getDateNowAdd(number, type) {
        return moment().add(number, type).format('LLLL')
    },
    getDateMomentAdd(date, number, type) {
        return moment(date).add(number, type).format('LLLL')
    },
    getDateNowByFormat(format) {
        return moment.utc().format(format)
    },
    getDateNowLocal(styleDate, local) {
        /**https://momentjs.com/docs/*/
        moment.locale(local);
        return moment().format(styleDate)
    },
    /**
     * @param date
     * @param dateformat
     * @returns date
     */
    parseDate(date, format) {
        if (date !== null) {
            return moment.parseZone(date).format(format)
        } else {
            return date
        }
    },
    parseMoney(money) {
        try {
            if (money == 'null' || money == null || money == undefined) {
                return 0
            }
            return (money).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        } catch (error) {
            return 0
        }
    },
    converMoney(money) {
        try {
            if (money == 'null' || money == null || money == undefined) {
                return 0
            }
            return (money.replaceAll(',', ''))
        } catch (error) {
            return 0
        }

    },
    getMomentTimestamp(date) {
        return moment(date).toDate();
    },
    /**
     * formatMoney(num, fix, type)
     * 
     * @param num Number parse
     * @param fix leng . number (123.00)
     * @param type   $, VND
     */
    formatMoney(money) {
        try {
            if (money == 'null' || money == null || money == undefined) {
                return 0
            }
            return new Intl.NumberFormat().format(money)
        } catch (error) {
            return 0
        }
    },
    getNumber(number) {
        try {
            if (number == 'null' || number == null || number == undefined) {
                return 0
            }
            return number
        } catch (error) {
            return 0
        }
    },
    getDateNowFomat(format) {
        let startDate = new Date()
        if (format !== null) {
            return moment.parseZone(startDate).format(format)
        } else {
            return startDate
        }
    },
    isNumber(number) {
        return /^-?[\d.]+(?:e-?\d+)?$/.test(number)
    },
    isDate(date) {
        return moment(date).isValid()
    },
    parseStringToFloatNumber(str) {
        return parseFloat(str);
    },
    setLocalStorageToken(key, value, ttl) {
        // ttl = (1000 * 60 * 20) would be 20 mins
        // `item` is an object which contains the original value
        // as well as the time when it's supposed to expire
        const item = {
            value: value,
            expiry: ttl <= 0 ? -1 : new Date().getTime() + ttl
        }
        localStorage.setItem(key, JSON.stringify(item))
    },
    setLocalStorage(key, value) {
        localStorage.setItem(key, value)
    },
    getLocalStorage(key) {
        return localStorage.getItem(key)
    },
    getLocalStorageToken(key) {
        const itemStr = localStorage.getItem(key)
        // if the item doesn't exist, return null
        if (!itemStr) {
            return null
        }
        const item = JSON.parse(itemStr)
        // compare the expiry time of the item with the current time
        if (item.expiry > 0 && new Date().getTime() > item.expiry) {
            // If the item is expired, delete the item from storage
            // and return null
            localStorage.removeItem(key)
            return null
        }
        return item.value
    },
    removeLocalStorageToken(key) {
        localStorage.removeItem(key)
    },
    randomText(lenght) {
        let text = ''
        let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
        for (let i = 0; i < lenght; i++) {
            text += chars.charAt(Math.floor(Math.random() * chars.length))
        }
        return text
    },
    proxyToJson(value) {
        return JSON.parse(JSON.stringify(value))
    },
    removevietnamese(value: String) {
        return value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    },
    dateToISOString(date: any) {
        let value = moment(date).toISOString();
        return value.substring(0, value.length - 1);
    },
    getStringFloor(data: any) {
        if (data > 1) {
            let number = Number(data) - 1
            return number + " tầng (Gồm 1 trệt + " + number + " tầng)"
        } else {
            return "Tầng trệt(Gồm 1 trệt)"
        }
    },
    inputNumber(evt: any) {
        const keysAllowed: string[] = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'];
        const keyPressed: string = evt.key;

        if (!keysAllowed.includes(keyPressed)) {
            evt.preventDefault()
        }
    }

}
export default Utils
